import { combineReducers } from 'redux';
import { authenticationReducer } from './authentication/reducers';
import { AppAction } from './index';

const createAppReducer = () =>
    combineReducers({
        authentication: authenticationReducer,
        configs: (configs = {}) => configs
    });

export const createRootReducer = () => {
    const appReducer = createAppReducer();

    return (state, action: AppAction) => {
        if (action.type === 'SOFT_RESET') {
            const { authentication } = state;
            state = { authentication };
        }
        return appReducer(state, action);
    };
};
